import React from 'react';
import PageHelmet from '../../components/seo/PageHelmet';
import Layout from '../../components/ui/Layout';
import { Container } from 'react-bootstrap';
import { CONTACT_INFO } from '../../constants/contact';

export default function TermsOfService() {
  return (
    <Layout>
      <PageHelmet
        title="Terms of Service | Pack My Cart"
        description="Terms and conditions for using Pack My Cart to shop groceries online from participating supermarkets in Jamaica."
        path="/terms-of-service"
        robots="index, follow"
      />
      <Container className="mt-4">
        <h1>Terms of Service</h1>
        <p>By using our website and services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.</p>
        <h4>Use of Our Service</h4>
        <ul>
          <li>You must be at least 18 years old or have parental consent to use our services.</li>
          <li>You agree not to misuse our services or attempt to disrupt our website.</li>
        </ul>
        <h4>Orders and Payments</h4>
        <ul>
          <li>All orders are subject to acceptance and availability.</li>
          <li>Payments must be made in full before orders are processed.</li>
        </ul>
        <h4>Contact Us</h4>
        <p>If you have any questions about these Terms, please contact us at {CONTACT_INFO.email}.</p>
      </Container>
    </Layout>
  );
} 